'use client';
import React from 'react';

import { Breadcrumbs } from '../../../../components/breadcrumbs';
import { SearchResults } from '../../../../components/search/search-results';
import useGetMobileAppWebViewHeader from '../../../../hooks/use-get-mobile-app-web-view';
import { IMeetingPlacePageSearchResults } from '@/lib/fragments/meetingPlacePageSearchResults';
import { IMeetingplacePageHomeMinified } from '@/lib/fragments/meetingPlacePageHome-minified';
import { GtmPageView } from '@/components/page-components/analytics/gtm-page-view';

interface MeetingPlacePageSearchResultsProps {
  metaData: any;
  node_locale: string;
  searchResultsData: {
    meetingPlacePageSearchResults: IMeetingPlacePageSearchResults | null;
    meetingPlacePageHome: IMeetingplacePageHomeMinified | null;
  };
}

const MeetingPlacePageSearchResults = ({
  metaData,
  node_locale,
  searchResultsData,
}: MeetingPlacePageSearchResultsProps) => {
  const page = searchResultsData?.meetingPlacePageSearchResults;
  const homepage = searchResultsData?.meetingPlacePageHome;

  const isWebView = useGetMobileAppWebViewHeader();

  if (!page) {
    return null;
  }

  return (
    <>
      {/* ✅ GTM PAGE VIEW */}
      <GtmPageView
        homepage={homepage}
        language={node_locale}
        pageTitle={page?.name ?? ''}
      />

      <main className="px-6 lg:px-0">
        <Breadcrumbs
          breadcrumbs={[page?.name]}
          homeText={homepage?.breadcrumbHomeText ?? ''}
          node_locale={node_locale}
          cssClass={isWebView ? '!pt-8' : ''}
        />

        <SearchResults
          title={page.title}
          noHitsText={page.noHitsText}
          noHitsTitle={page.noHitsTitle}
          noHitsImage={page.noHitsImage}
          node_locale={node_locale}
        />
      </main>
    </>
  );
};

export default MeetingPlacePageSearchResults;
